import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  box: {
    margin: 10,
  },
  listItem: {
      borderRadius:10,
    transition: "background 0.3s, color 0.3s",
    "&:hover": {
    backgroundColor:theme.palette.background.default,
    //color:"white"
 
    }
  },
  pagination: {
    display: "flex",
    padding: 10,
    justifyContent: "center",
  },
}));
